var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-receive-badge',{attrs:{"name":"w3d3badge1","bg-path":"/images/game/w3d3/w3d3_badge_bg.png","bubble-text":"Du hast den Strom perfekt in die Stadt geleitet.\nDu bekommst eine Auszeichnung."}})}
var staticRenderFns = []

export { render, staticRenderFns }